'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './navBar';
import SideMenu from './sideMenu';
import DetailContent from './reportComponents/detailContent';
import reportAction from '../actions/reportAction';
import reportStore from '../stores/reportStore';
import menuAction from '../actions/menuAction';

class ReportDetail extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state={
           reportDetail:reportStore.getState().reportDetail
        };
    }
    componentWillMount(){
        
    }
    componentDidMount(){
        reportStore.listen(this.onChange);
        menuAction.pageNumber(-1);
        reportAction.getDetailReport(this.props.match.params.id);    
    }
    componentWillUnmount() {
        reportStore.unlisten(this.onChange);
    }

    onChange(state){
        this.setState({
            reportDetail: state.reportDetail,
        });
    }

    render() {
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props}/>
                    <SideMenu {...this.props}/>
                    <div className=" col-md-8  col-sm-8">
                        <DetailContent reportDetail={this.state.reportDetail}/>
                    </div>
                </div>
            </div>
        );
    }
}
export default ReportDetail;


// WEBPACK FOOTER //
// ./app/components/reportDetail.js